/* eslint-disable */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(["chartist"], function (Chartist) {
      return (root.returnExportsGlobal = factory(Chartist));
    });
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like enviroments that support module.exports,
    // like Node.
    module.exports = factory(require("chartist"));
  } else {
    root['Chartist.plugins.ctPointLabels'] = factory(Chartist);
  }
}(this, function (Chartist) {

  /**
   * Chartist.js plugin to display a data label on top of the points in a line chart.
   *
   */
  /* global Chartist */
  (function(window, document, Chartist) {
    'use strict';

    var defaultOptions = {
      labelClass: 'ct-percentile-label',
      labelOffset: {
        x: 0,
        y: -10
      },
      textAnchor: 'middle',
      align: 'center',
      labelInterpolationFnc: Chartist.noop
    };

    Chartist.plugins = Chartist.plugins || {};
    Chartist.plugins.ctPointLabels = function(options) {

      options = Chartist.extend({}, defaultOptions, options);

      function addLabel(data) {
        const { label } = data.series.data[0];
        data.group.elem('text', {
          x: data.x + options.labelOffset.x,
          y: data.y + options.labelOffset.y,
          style: 'text-anchor: ' + options.textAnchor
        }, options.labelClass).text(label || '');
      }

      return function ctPointLabels(chart) {
        if (chart instanceof Chartist.Line) {
          chart.on('draw', function(data) {
            if (data.type === 'point') {
              addLabel(data);
            }
          });
        }
      };
    };

  }(window, document, Chartist));

  return Chartist.plugins.ctPointLabels;

}));



// WEBPACK FOOTER //
// ./client/src/chartist-plugin-pointlabels.js